<template>
    <div class="page-wrapper flex margin-left-sm">
        <div class="report-info flex flex-direction padding bg-white radius-lg">
            <div class="text-black text-df">项目信息</div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form margin-top" label-position="top" label-width="auto">
                <el-form-item ref="p_name" label="项目名称" prop="p_name">
                    <el-input v-model="ruleForm.p_name" disabled placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item ref="time" label="起止日期" prop="time">
                    <el-date-picker
                        v-model="ruleForm.time"
                        :disabled="is_node || readonly"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期" type="daterange">
                    </el-date-picker>
                </el-form-item>
                <el-form-item ref="report_node" label="汇报节点" prop="report_node">
                    <el-select v-model="ruleForm.report_node" :disabled="is_node || readonly" placeholder="请选择">
                        <el-option
                            v-for="item in report_node"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button v-if="!is_node && !readonly" class="btn max bg-orange radius self-center margin-top-sm" type="warning" @click="submitNode()">
                保存
            </el-button>

        </div>
        <div class="flex-sub flex flex-direction padding bg-white radius-lg margin-left-sm">
            <div class="flex flex-direction">
                <div class="title  flex align-center justify-between">
                    <div class="text-black text-lg">沟通汇报信息</div>
                    <el-button v-if="is_node && !readonly" class="btn max bg-orange radius" type="warning" @click="addNode(false)">
                        专项汇报添加
                    </el-button>
                </div>
                <div class="flex flex-direction padding-left"  v-if="lists.length" >
                    <div v-for="(item, index) in lists" :key="index"
                         class="node-item flex flex-direction margin-top-sm">
                        <div class="title  flex align-center justify-between padding-lr-sm">
                            <div class="text-black text-sm text-bold">
                                {{ item.r_time }}<span class="margin-left-sm">{{ item.type === 1 ? '沟通汇报' : '专项汇报' }}</span>
                            </div>
                            <div class="flex align-center" v-if="!readonly">
                                <el-button class="radius" style="width: 190px" type="primary" size="small" @click="addNode(item)">上传汇报材料/委托方反馈</el-button>
                                <el-button class="radius" style="width: 120px" type="primary" size="small" @click="addNode(item)">沟通汇报纪要</el-button>
                                <el-button class="radius" style="width: 80px" plain size="small" @click="delNode(item)">删除</el-button>
                            </div>
                        </div>
                        <div class="content padding-sm" v-if="item.file.left || item.desc">
                            <div>{{item.desc}}</div>
                            <div class="flex margin-top-xs">
                                <div class="text-xs text-black text-bold">附件</div>
                                <div class="flex flex-direction margin-left-xs flex-sub">
                                    <div class="text-xs file-name margin-bottom-xs" :href="item.url" target="_blank"
                                         v-for="(item,index) in item.file" :key="index" @click="toFilePreview(item.name,item.url)">{{item.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <empty v-else class="self-center" tip="请先生成节点"></empty>
            </div>
        </div>
        <report-node-dialog :dialog-visible="addNodeDialog" :pid="pid" :pname="pname" :nid="cur_nid" :info="cur_node" @watchState="watchState"></report-node-dialog>
    </div>
</template>

<script>


import {report_node} from "@/utils/const";
import {delProjectReport, getProjectReportNode, getProjectStatus, setProjectReportNode} from "@/api";
import {confirm, formatHtml, TOAST, toast, toFilePreview} from "@/utils/utils";
import ReportNodeDialog from "@/views/web/staff/components/ReportNodeDialog";

export default {
    name: "project-report",
    components: {ReportNodeDialog},
    data() {
        return {
            pid: 0,
            pname: '',
            report_node: report_node,
            ruleForm: {
                p_name: '',//	是项目名称
                time: [],
                report_node: 1,
            },
            rules: {},
            lists: [],
            cur_nid:0,
            cur_node:'',
            addNodeDialog:false,
            is_node: true,//是否设置过
            readonly: true,
        }
    },
    created() {
        this.pid = Number(this.$route.params.id || 0)
        this.pname = this.$route.params.title
        this.$emit('setIndex', [1,0], `${this.pname} 项目汇报`, true)
        this.getProjectStatus()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async getProjectStatus(){
            let _data = await getProjectStatus(this.pid)
            this.readonly =  _data.data.is_operation === 0
        },
        async init() {
            let _data = await getProjectReportNode(this.pid)
            this.ruleForm.p_name = _data.data.project.p_name
            this.ruleForm.time = _data.data.project.start_time && _data.data.project.end_time ? [_data.data.project.start_time, _data.data.project.end_time] : []
            this.ruleForm.report_node = _data.data.project.report_node || 1
            _data.data.reportList.map(item=>{
                item.file = item.file ? JSON.parse(item.file) : []
                item.desc = formatHtml(item.content)
            })
            this.lists = _data.data.reportList
            this.is_node = _data.data.project.report_node !== 0
        },
        async submitNode() {
            if (!this.ruleForm.time.length) return toast('请选择起止日期', TOAST.error)
            let _data = await setProjectReportNode(this.pid, this.ruleForm.p_name, this.ruleForm.time[0], this.ruleForm.time[1], this.ruleForm.report_node)
            if (_data.status === 200) {
                toast('保存成功', TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        delNode(item){
            confirm(`删除节点`,`你确定删除<b>${item.r_time}</b>节点吗？`,()=>{
                this.delNodeItem(item.id)
            },'确认',true)
        },
        async delNodeItem(id){
            let _data = await delProjectReport(id)
            if (_data.status === 200) {
                toast(`删除成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        addNode(data){
            if (data) {
                this.cur_nid = data.id
                this.cur_node = data
            }else {
                this.cur_nid = 0
                this.cur_node = ''
            }
            this.addNodeDialog = true;
        },
        watchState(data) {
            if (data) this.init()
            this.addNodeDialog = false
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        }
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .report-info {
        width: 363px;
    }

    .content{
        border-top: solid 1px #e6e6e6;
    }
    .node-item{
        border-radius: 10px;
        border: solid 1px #e6e6e6;
        position: relative;
        &::before{
            position: absolute;
            content: '';
            width: 18px;
            height: 18px;
            border-radius: 18px;
            background-color: var(--orange);
            left: -30px;
            top: 30px;
        }
        &:not(:last-child) {
            &::after{
                position: absolute;
                content: '';
                width: 3px;
                background-color: var(--orange);
                left: -22px;
                top: 30px;
                bottom: -60px;
            }
        }
        .title {
            height: 82px;
        }
    }

}
</style>
